<template>
    <div>
        <div style="margin-bottom: 10px;">
            <div v-if="type==='mobile'">
                <el-upload v-if="userType === 'stu' && !markState"
                           :accept="'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'"
                           :before-upload="beforeUpload"
                           class="upload-demo" action
                           :http-request="uploadReport" :show-file-list="false"
                           :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </div>

            <div v-else>
                <el-upload v-if="userType === 'stu' && !markState" accept=".doc,.docx,.xls,.xlsx,.pdf"
                           class="upload-demo" action
                           :http-request="uploadReport" :show-file-list="false"
                           :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </div>


            <!--            <el-button v-if="userType === 'tea' || (userType === 'stu' && markState)" @click="mark" type="warning"-->
            <!--                       size="small">-->
            <!--                <i v-if="userType === 'tea'" class="el-icon-edit"/>-->
            <!--                <i v-if="userType === 'stu'" class="el-icon-view"/>-->
            <!--                &nbsp;点评-->
            <!--            </el-button>-->
        </div>
        <div style="height: 555px;">

            <el-table v-if="type === 'mobile'" :data="reportListData" ref="reportListTable" height="250" stripe
                      border fit
                      highlight-current-row header-cell-class-name="tableHeadStyle" style="width:100%;">
                <el-table-column label="文件名" prop="fileName" align="center"/>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <button
                            style="background-color: #409eff;border: none;width: 40px;height: 30px"
                            @click="fileDownload(scope.row)"><span style="font-size: 12px;color: #FFFFFF">下载</span>
                        </button>
                        <button
                            style="background-color: #409eff;border: none;width: 40px;height: 30px"
                            @click="fileShow(scope.row)"><span style="font-size: 12px;color: #FFFFFF">预览</span></button>
                        <button v-if="userType === 'stu' && !markState"
                                style="background-color: #f56c6c;border: none;width: 40px;height: 30px"
                                @click="fileDelete(scope.row)"><span style="font-size: 12px;color: #FFFFFF">删除</span>
                        </button>
                    </template>
                </el-table-column>
            </el-table>
            <el-table v-else :data="reportListData" ref="reportListTable" height="250" stripe
                      border fit
                      highlight-current-row header-cell-class-name="tableHeadStyle" style="width:100%;">
                <el-table-column label="文件名" prop="fileName" align="center"/>
                <el-table-column label="操作" width="280px" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="fileDownload(scope.row)">
                            <i class="el-icon-download"></i>&nbsp;下载
                        </el-button>
                        <el-button type="primary" size="small" @click="fileShow(scope.row)">
                            <i class="el-icon-view"></i>&nbsp;预览
                        </el-button>
                        <el-button v-if="userType === 'stu' && !markState" type="danger" size="small"
                                   @click="fileDelete(scope.row)">
                            <i class="el-icon-delete-solid"></i>&nbsp;删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <el-form ref="markForm" :model="markForm" label-width="100px" label-position="left">
                    <div v-if="userType === 'stu' && markState">
                        <el-form-item label="点评内容">
                            <el-input type="textarea" :rows="3" maxlength="500" show-word-limit
                                      v-model="markForm.content" :readonly="true"/>
                        </el-form-item>
                        <el-form-item label="点评成绩">
                            <span>{{ parseScore(markForm.score) }}</span>
                        </el-form-item>
                    </div>
                    <div v-if="userType === 'tea'">
                        <el-form-item label="点评内容" prop="content"
                                      :rules="[{required: true, message: ' '}]">
                            <el-input type="textarea" :rows="5" maxlength="500" show-word-limit
                                      v-model="markForm.content" :readonly="userType === 'stu'"/>
                        </el-form-item>
                        <el-form-item label="点评成绩" prop="score"
                                      :rules="[{required: true, message: ' '}]">
                            <el-select v-model="markForm.score" filterable placeholder="请选择"
                                       style="width:100%;">
                                <el-option v-for="item in scoreCombo" :key="item.comboValue" :label="item.comboName"
                                           :value="item.comboValue"/>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div style="width:100%; text-align:center; margin:10px 0 10px 0;">
                    <el-button v-if="userType === 'tea'" type="primary" @click="saveScore">保 存</el-button>
                    <!--                    <el-button @click="markDialogVisible = false">关 闭</el-button>-->
                </div>
                <br>
            </div>
        </div>

        <!-- 文件预览 -->
        <previewer v-if="previewerVisible" ref="previewer" :fileInfo="fileInfo"
            :widthPercent="previewDialogWidth" :heightNum="650" :topNum="60"
            @closePreviewer="previewerVisible = false;">
        </previewer>
        <!--        <el-dialog title="点评" :visible.sync="markDialogVisible" v-if="markDialogVisible" width="700px" top="300px"-->
        <!--                   append-to-body @close="closeMark">-->
        <!--            <div>-->
        <!--                <el-form ref="markForm" :model="markForm" label-width="150px" label-position="left">-->
        <!--                    <el-form-item label="点评内容" prop="content"-->
        <!--                                  :rules="[{required: true, message: ' '}]">-->
        <!--                        <el-input type="textarea" :rows="5" maxlength="500" show-word-limit-->
        <!--                                  v-model="markForm.content" :readonly="userType === 'stu'"/>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="点评成绩" prop="score"-->
        <!--                                  :rules="[{required: true, message: ' '}]">-->
        <!--                        <el-select v-if="userType === 'tea'" v-model="markForm.score" filterable placeholder="请选择" style="width:100%;">-->
        <!--                            <el-option v-for="item in scoreCombo" :key="item.comboValue" :label="item.comboName"-->
        <!--                                       :value="item.comboValue"/>-->
        <!--                        </el-select>-->
        <!--                       <span v-else>{{parseScore(markForm.score)}}</span>-->
        <!--                    </el-form-item>-->
        <!--                </el-form>-->
        <!--                <div style="width:100%; text-align:center; margin:10px 0 10px 0;">-->
        <!--                    <el-button v-if="userType === 'tea'" type="primary" @click="saveScore">保 存</el-button>-->
        <!--                    <el-button @click="markDialogVisible = false">关 闭</el-button>-->
        <!--                </div>-->
        <!--                <br>-->
        <!--            </div>-->
        <!--        </el-dialog>-->
    </div>
</template>

<script>
import {confirmMsg, showNotify} from "../../utils/message";
import {globalConfig} from "../../../static/config";
import previewer from "views/file/previewer";

export default {
    components: {
        previewer
    },
    props: ['userCode', 'userType', 'stuCode', 'teaCode', 'id', 'previewDialogWidth', 'type'],
    data() {
        return {
            fileData: [],
            fileName: '',
            fileInfo: {
                name: '',
                type: '',
                url: ''
            },
            previewerVisible: false,

            reportListData: [],
            fileList: [],
            loadingMask: null,

            markDialogVisible: false,
            markForm: {
                content: '',
                score: ''
            },
            scoreCombo: [],
            markState: false,

            downloadUrl: ''
        }
    },
    mounted() {
        if (this.previewDialogWidth == '90%') {
            this.previewDialogWidth = 90
        }else{
            this.previewDialogWidth = 60
        }

        this.loadReportList()
        this.loadScoreCombo()
        this.delFile()
    },
    methods: {
        parseScore(score) {
            let str = ''
            this.scoreCombo.forEach(item => {
                if (score === item.comboValue) {
                    str = item.comboName
                }
            })
            return str;
        },
        closeMark() {
            if (this.$refs['markForm'] !== undefined) {
                this.$refs['markForm'].clearValidate();
                this.$refs['markForm'].resetFields();
            }
        },
        loadMark() {
            this.$api.postPracticeManage.report.loadMark({
                data: this.id
            }).then((res) => {
                if (res.data.data !== null) {
                    this.markForm.content = res.data.data.content
                    this.markForm.score = res.data.data.score
                }
            }).catch((error) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        saveScore() {
            this.$refs.markForm.validate((valid) => {
                if (valid) {
                    let form = {
                        'id': this.id,
                        'teaCode': this.teaCode,
                        'stuCode': this.stuCode,
                        'content': this.markForm.content,
                        'score': this.markForm.score
                    }
                    this.$api.postPracticeManage.report.saveScore({
                        data: form
                    }).then((res) => {
                        let state = res.data.data;
                        switch (state) {
                            case 'success':
                                showNotify('成功', '保存成功', 'success', 1500);
                                this.callback()
                                break;
                            default:
                                showNotify('错误', '保存失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                } else {
                    return false;
                }
            });
        },
        loadScoreCombo() {
            this.$api.postPracticeManage.report.loadScoreCombo({}).then((res) => {
                this.scoreCombo = res.data.data
            }).catch((err) => {
                console.log(err);
            });
        },
        loadReportList() {
            this.$api.postPracticeManage.report.loadReportList({
                data: this.stuCode
            }).then((res) => {
                this.reportListData = res.data.data.list
                if (this.userType === 'stu') {
                    if (res.data.data.id != null) {
                        this.markState = true
                        this.id = res.data.data.id
                        this.loadMark()
                    } else {
                        this.markState = false
                    }
                } else {
                    if (res.data.data.id != null) {
                        this.loadMark()
                    }
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        beforeUpload(file) {
            var testmsg = (file.name.substring(file.name.lastIndexOf(".") + 1)).toLocaleLowerCase();;
            const extension1 = testmsg === "doc";
            const extension2 = testmsg === "docx";
            const extension3 = testmsg === "xls";
            const extension4 = testmsg === "xlsx";
            const extension5 = testmsg === "pdf";
            if (!extension1 && !extension2 && !extension3 && !extension4 && !extension5) {
                this.$message({
                    message: "仅允许上传 doc、docx、xls、xlsx、pdf 文件！",
                    type: "info",
                    offset: 80,
                });

                return false;
            } else {
                return true;
            }
        },
        uploadReport(param) {
            this.showLoadingMask("实习文件上传中，请稍候...")
            let formData = new FormData()
            formData.append('userCode', this.stuCode)
            formData.append('file', param.file)
            this.$api.postPracticeManage.report.uploadReport({
                data: formData
            })
                .then((res) => {
                    let state = res.data.data;
                    switch (state) {
                        case 'success':
                            showNotify('成功', '上传成功', 'success', 1500);
                            this.loadReportList()
                            break;
                        default:
                            showNotify('错误', '上传失败', 'error', 3000);
                            break;
                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                this.closeLoadingMask();
            });
        },
        fileDelete(rowData) {
            confirmMsg('是否确定要删除当前选择文件？').then(() => {
                this.$api.postPracticeManage.report.fileDelete({
                    data: rowData.id,
                }).then((res) => {
                    let state = res.data.data;
                    switch (state) {
                        case 'success':
                            showNotify('成功', '保存成功', 'success', 1500);
                            this.loadReportList()
                            break;
                        default:
                            showNotify('错误', '保存失败', 'error', 3000);
                            break;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        fileShow(rowData) {
            this.fileInfo.name = rowData.fileName;
            this.fileInfo.type = rowData.fileType;
            this.fileInfo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.previewPath;
            this.fileName = rowData.fileName + '.' + rowData.fileType;
            this.previewerVisible = true;
        },
        delFile(){
            this.$api.postPracticeManage.stuPractice.delFile({
                data: this.stuCode
            }).then((res) => {
            }).catch((error) => {
            });
        },
        fileDownload(rowData) {
            // 文件下载链接
            const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi;
            let exist = this.isExistFile(fileUrl+rowData.filePath);
            if (exist) {
                if (this.type === 'mobile') {
                    this.$api.postPracticeManage.stuPractice.download({
                        data: {
                            'filePath': rowData.filePath,
                            'fileName': rowData.fileName,
                            'fileType': rowData.fileType,
                            'stuCode':this.stuCode
                        },
                    }).then((res) => {
                        if (res.data.data !== 'fail') {
                            let furl = fileUrl + res.data.data;
                            //创建隐藏的下载链接
                            const link = document.createElement('a');
                            link.href = furl;
                            // 兼容性处理
                            if (navigator.userAgent.indexOf('Trident') > -1) { // IE浏览器
                                const ieDownloadFrame = document.createElement('iframe');
                                ieDownloadFrame.src = furl;
                                ieDownloadFrame.style.display = 'none';
                                document.body.appendChild(ieDownloadFrame);
                            } else if (navigator.userAgent.indexOf('Edge') > -1 || navigator.userAgent.indexOf('Edg') > -1) { // Edge浏览器
                                link.click(); // 直接触发链接点击事件
                            } else { // 其他浏览器
                                link.dispatchEvent(new MouseEvent('click'));
                            }
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                } else {
                    this.downloadFile(fileUrl, rowData.fileName + '.' + rowData.fileType);
                }

            } else {
                showNotify('错误', '文件不存在，如有疑问请联系管理员！', 'error', 3000);
            }
        },
        downloadFile(url, fileName) {
            let x = new XMLHttpRequest();
            x.open("GET", url, true);
            x.responseType = 'blob';
            x.onload = function (e) {
                var url = window.URL.createObjectURL(x.response)
                var a = document.createElement('a');
                a.href = url
                a.download = fileName;
                a.click()
            }
            x.send();
        },
        isExistFile(url) {
            if (url == null || url == undefined || url == "") {
                return false;
            }
            let xmlhttp;
            if (window.XMLHttpRequest) {
                xmlhttp = new XMLHttpRequest();
            } else {
                xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            }
            xmlhttp.open("GET", url, false);
            xmlhttp.send();
            if (xmlhttp.readyState == 4) {
                if (xmlhttp.status == 200) return true;
                //url存在
                else if (xmlhttp.status == 404) return false;
                //url不存在
                else return false; //其他状态
            }
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        callback() {
            this.$emit("callback");
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// report.vue?72af65b6